export default __webpack_public_path__ + "static/media/loyal-web.d87e9fc5.jpg";